import {AxiosError} from "axios";
import { create } from 'zustand';

import {
  ChangePasswordState,
  InitialChangePasswordState,
} from "../model/auth.model";
import {AuthService} from "../api/auth.service";

const initialState: InitialChangePasswordState = {
  message: null,
  loading: false,
  error: null
};

export const changePasswordStore = create<ChangePasswordState>((set, get) => ({
  ...initialState,

  changePassword: async (username: string, password: string, token: string) => {
    try {
      set({
        loading: true
      })

      const restoreRes = await AuthService.changePassword(username, password, token);

      set({
        loading: false,
        error: null,
        message: restoreRes.data.message
      })
    } catch (err) {
      const error = err as AxiosError<Error>
      set({
        loading: false,
        error: error,
        message: null
      })
    }
  },
}));
